import localFont from 'next/font/local';

const plusJakartaSans = localFont({
  src: [
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-semibold.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../public/fonts/plusjakartasans/plusjakartasans-extrabold.woff2',
      weight: '800',
      style: 'normal',
    },
  ],
  variable: '--font',
  display: 'swap',
});

export const fontClassNames = plusJakartaSans.variable;
